import type { Step } from "react-joyride";

/**
 * Versione 2 (2026-09-12): menù ridotto a un passo d'apertura, canali accorpati,
 * blocco «Per stato» e striscia delle utenze ferme.
 *
 * Sotto 768px la sidebar non è nel DOM: i passi `sidebar-*` vengono scartati da
 * OnboardingTour e resta il passo sul pulsante del menù in testata.
 */
export const dashboardVersion = 2;

export const dashboardSteps: Step[] = [
  {
    target: '[data-tour="header-menu"]',
    title: "Il menù",
    content: (
      <p>
        Da qui si apre il menù: le pratiche, i clienti, i canali per parlare con
        l'assistente. Resta a portata di mano su ogni pagina.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="sidebar-nav"]',
    title: "Il menù",
    content: (
      <p>
        Da qui si raggiunge tutto: le pratiche, i clienti, i canali per parlare
        con l'assistente. La voce in evidenza è la pagina dove ti trovi.
      </p>
    ),
    placement: "right",
    skipBeacon: true,
  },
  {
    target: '[data-tour="sidebar-chat"]',
    title: "Consulenza",
    content: (
      <p>
        L'assistente con cui si apre una pratica: carichi la bolletta, confronti
        le offerte, raccogli i dati del cliente. Risponde con i listini
        aggiornati.
      </p>
    ),
    placement: "right",
    skipBeacon: true,
  },
  {
    target: '[data-tour="sidebar-pratiche"]',
    title: "Pratiche",
    content: (
      <p>
        L'elenco dei contratti. Si cerca per cliente, si filtra per stato e si
        apre la scheda di ognuno.
      </p>
    ),
    placement: "right",
    skipBeacon: true,
  },
  {
    target: '[data-tour="sidebar-telegram"]',
    title: "Lo stesso assistente dal telefono",
    content: (
      <div>
        <p>
          Su Telegram — e su WhatsApp dove attivo — risponde lo stesso
          assistente. Serve soprattutto per fotografare la bolletta del cliente
          mentre sei da lui.
        </p>
        <p className="mt-2 text-xs text-muted-foreground">
          La prima volta il canale chiede di collegarsi al tuo account.
        </p>
      </div>
    ),
    placement: "right",
    skipBeacon: true,
  },
  {
    target: '[data-tour="sidebar-supporto"]',
    title: "Supporto live",
    content: (
      <p>
        Quando qualcosa non torna, da qui chiedi aiuto a un supervisore, che vede
        la tua schermata mentre ne parlate.
      </p>
    ),
    placement: "right",
    skipBeacon: true,
  },
  {
    target: '[data-tour="sidebar-news"]',
    title: "Novità",
    content: (
      <p>
        Comunicazioni dell'azienda: listini nuovi, avvisi, manutenzioni. Il
        numero accanto alla voce conta quelle non ancora lette; le urgenti
        compaiono all'accesso.
      </p>
    ),
    placement: "right",
    skipBeacon: true,
  },
  {
    target: '[data-tour="stato-utenze"]',
    title: "Se l'invio è fermo",
    content: (
      <p>
        Quando il collegamento con un fornitore cade, la riga compare qui sotto
        la testata. Finché resta, le pratiche pronte restano in coda.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="dashboard-kpi"]',
    title: "I numeri",
    content: (
      <p>
        Pratiche totali, quante restano da lavorare e quanti clienti hai. Si
        clicca per entrare nell'elenco.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="dashboard-stati"]',
    title: "Per stato",
    content: (
      <p>
        Come sono distribuite le pratiche lungo il percorso, dalla bozza
        all'attivazione.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="dashboard-help"]',
    title: "Rivedi la guida",
    content: (
      <p>
        Questa spiegazione si riapre da qui quando serve. Lo stesso pulsante c'è
        su ogni pagina.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
];
